import { Component, OnInit, Input } from '@angular/core';
import { FormInputParam } from '../form-input-params';
import { FormControl, AbstractControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { startWith, map, debounceTime, filter, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'lib-common-autocomplete',
  templateUrl: './common-autocomplete.component.html',
  styleUrls: ['./common-autocomplete.component.scss']
})
export class CommonAutocompleteComponent implements OnInit {

  @Input() params: FormInputParam;
  @Input() searchFn!: (term: string) => Observable<any[]>;
  Object = Object;
  myControl: AbstractControl;
  filteredOptions: Observable<string[]>;
  proxyValue: any;
  defaultVal;
  constructor() { }

  ngOnInit() {

    const formControlName = this.params.formControllName;
    this.myControl = this.params.formGroup.controls[formControlName];

    this.filteredOptions = this.myControl.valueChanges.pipe(
      debounceTime(300),
      filter(value => typeof value === 'string' && value.length >= 3),
      distinctUntilChanged(),
      switchMap(value => this.searchFn(value).pipe(
        map(results =>
          results.map((item, index) => ({
            ...item,
            gtmTag: `FFQ__BI_Weblead_industry${item.value}_dropdown`
          }))
        )
      ))
    );
  }


  displayFn = (value) => {
    if (value) {
      const selection = this.params.values.find(e => e.value === value.value);
      return selection ? selection.label : '';
    }
  }

  onSelectionChanged(event$) {
    this.proxyValue = event$.option.value.value;
  }

}
